import { IGarageList } from "../interfaces/Interfaces";
import { garageConfig } from "../enums/GarageType";
import { cityConfig } from "../enums/City";

export const buildTypeOptions = (data: IGarageList[]) => {
    const typesInData = new Set(data.map((item) => item.type));
    return garageConfig
        .filter((t) => typesInData.has(t.name))
        .map((t) => ({
            id: t.name,
            name: t.locaId,
        }));
};

export const buildCityOptions = (data: IGarageList[]) => {
    const citiesInData = new Set(data.map((item) => item.city));
    return cityConfig
        .filter((c) => citiesInData.has(c.name))
        .map((c) => ({
            id: c.name,
            name: c.locaId,
        }));
};
